import { render } from 'preact-render-to-string';
import { Line, BasicEmailWrapper, PrimaryAction, SupportFooter, Heading } from './shared';
import { Tenant } from 'server/types';

export function AccountRestricted({ tenant }: { tenant: Tenant }) {
  const actionUrl = `https://${tenant.domain}/account/billing`;

  return render(
    <BasicEmailWrapper footer={<SupportFooter email={tenant.email} />}>
      <Heading>We've converted your account to our limited plan.</Heading>
      <Line>
        You still have access to all of your courses. You're limited to a maximum of 5 student
        signups (across all of your courses). To register more students, you'll need to{' '}
        <a href={actionUrl}>sign up for a paid plan</a>.
      </Line>
      <Line>
        Questions? We're here to help anytime at{' '}
        <a href={`mailto:${tenant.email}`}>{tenant.email}</a>
      </Line>
      <PrimaryAction href={actionUrl}>Manage your account</PrimaryAction>
    </BasicEmailWrapper>,
  );
}
